// src/features/records/components/NoteView/RecordTags.js
import React from 'react';
import styles from './RecordTags.module.css';
import { sanitizeText } from '../../../../utils/sanitize';

const RecordTags = ({ tags }) => {
  const handleTagClick = (e, tag) => {
    e.stopPropagation();
    // TODO: Implement tag search functionality
    console.log('Search for tag:', tag);
  };

  return (
    <div className={styles.recordTags}>
      {tags.map((tag, index) => (
        <span 
          key={index} 
          className={styles.tag}
          onClick={(e) => handleTagClick(e, tag)}
        >
          {sanitizeText(tag)}
        </span>
      ))}
    </div>
  );
};

export default RecordTags;